// Just a fair warning that this is a bit of an anti pattern,
// it almost guarantees that we'll end up requiring things
// that won't be used.
//
// We just can't really avoid it at the moment because the
// bulk of page initialization still rests on backbone, and
// therefore jquery's shoulders, which need to be preconfigured.
//
// Once we start cleaning up that stuff, we should aim to remove
// as much from this "common" file as possible.
//
// ...and please don't add to it :)

// only do this once!
import "lib/polyfill"

// Lazysizes provides lazy loading for responsive images.
import "lazysizes"

// We still have a couple of UJS things hanging around
import Rails from "rails-ujs"

// set up backbone and it's dependencies
import $ from "jquery"
import Backbone from "backbone"
import "lib/csrfFormToken"

Backbone.$ = $

// Each entrypoint calls addCSRFTokenToAjaxRequests itself, because
// fetching the token costs a request to Rails on pages the CDN caches.

// Guard against duplicate execution when navigating with Turbo.
if (!window.__tcRailsUjsStarted) {
  Rails.start()
  window.__tcRailsUjsStarted = true
}
